import React from 'react';

export function getDefaultContext() {
  // default value
  return {
    appInfo: null,
    task:'qa'
  }
}

export const AppContext = React.createContext({});